import { ChevronRight } from 'lucide-react';

interface SuggestedQuestionsProps {
  onQuestionSelect: (question: string) => void;
}

const questions = [
  'What is this video about?',
  "What's the most interesting fact?",
  'What are the key points discussed?',
  'Can you give me a timeline of the main events?',
];

export const SuggestedQuestions = ({ onQuestionSelect }: SuggestedQuestionsProps) => {
  return (
    <div className="w-full">
      <p className="mb-3 text-sm font-medium text-gray-600">Suggested Questions</p>
      <div className="grid grid-cols-1 gap-3 md:!grid-cols-2">
        {questions.map((q) => (
          <button
            key={q}
            onClick={() => onQuestionSelect(q)}
            className="flex items-center justify-between rounded-lg border !border-border !bg-white hover:!bg-white p-3 text-left text-sm !text-gray-700 transition-shadow hover:!shadow-md overflow-hidden"
          >
            <span className="truncate">{q}</span>
            <ChevronRight className="h-4 w-4 !text-gray-400" />
          </button>
        ))}
      </div>
    </div>
  );
};
